module.exports = __webpack_public_path__ + "static/media/Fabrication CAM Duct Components.e1944b56.png";